import {Component, OnInit, ViewChild} from '@angular/core';
import {JhiLanguageService} from 'ng-jhipster';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {MassSmsComponent} from '../../../shared/mass-sms/mass-sms.component';
import {ApiService} from '../../../shared/services/api.service';
import {MarketOverviewViewEntry} from '../../../entities/market-overview-view-entry.model';
import {Branch, Contact, Marketdate, Marketplace} from '../../../entities';
import {IMyDrpOptions} from 'mydaterangepicker';
import * as moment from 'moment';
import {Filter, FilterOption} from '../../../interfaces/filter.interface';
import {Message, MessageType} from '../../../entities/message.model';
import {MerchantContact} from '../../../entities/merchant-contact.model';
import {classToClass} from 'class-transformer';
import {Principal, User} from '../../../shared';
import { ContactStatus } from "app/entities/contact.model";
import {MerchantService} from '../../../shared/services/merchant.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styles: []
})
export class MessagesComponent implements OnInit {

  @ViewChild('messageModal') private messageModal;
  @ViewChild('selectEmployeeModal') private employeeModal;
  @ViewChild('selectDateModal') private selectDateModal;
  @ViewChild('marketDiaryModal') private marketDiaryModal;
  @ViewChild('marketDiaryEntryModal') private marketDiaryEntryModal;
  @ViewChild('selectReceiverModal') private selectReceiverModal;

  public contactSelection: (Contact | MerchantContact)[];
  public allContacts: Contact[];
  public filteredContacts: Contact[];
  public loadingIndicator = false;

  public allMarketdates: Marketdate[];
  public filteredMarketdates: Marketdate[];
  public selectedMarketdates: Marketdate[];

  public marketplaces: Marketplace[];
  public branches: Branch[];
  public branchesWithCommunes: {branch: Branch, communes: string[]}[];
  public selectedCommunes = [];
  public diaryMessage: string;

  public federalStates: string[] = [];
  public selectedFederalStates: string[] = [];
  public selectedFederalState: string;

  public merchantContacts: MerchantContact[];
  public allMerchantContacts: MerchantContact[];

  // selectReceipientModal
  public selectedRecipientGroupValue: string = null;
  public selectedBranchId: number = null;
  public selectedCommune: string = null;

  private finalContacts: {
    markets: MarketOverviewViewEntry[],
    contact: Contact
  }[];

  modalRef: NgbModalRef = null;
  recipientGroups: FilterOption[];
  shouldReload = false;
  loadingOverlay = false;

  // Select planned markets properties
  allMarkets: MarketOverviewViewEntry[];
  filteredMarkets: MarketOverviewViewEntry[];
  selectedMarkets: MarketOverviewViewEntry[];

  dateRangePickerOptions: IMyDrpOptions;
  dateRangeModel;

  // Filters
  branchFilter: Filter;
  communeFilter: Filter;
  functionFilter: Filter;
  appPermissionFilter: Filter;
  recipientFilter: Filter;

  account: User;

  constructor(
    private jhiLanguageService: JhiLanguageService,
    public modalService: NgbModal,
    private apiService: ApiService,
    private principal: Principal,
    private merchantService: MerchantService
  ) {
    this.initDateRangePicker();
    this.jhiLanguageService.setLocations(['messages']);
    this.principal.identity().then((account: User) => {
      this.account = account;
    });
  }

  ngOnInit() {}

  initDateRangePicker() {
    const now = moment();
    const endDate = moment().add(7, 'days');
    const nextMonth = moment().add(1, 'months');
    this.dateRangePickerOptions = {
      dayLabels: {su: 'So', mo: 'Mon', tu: 'Di', we: 'Mi', th: 'Do', fr: 'Fr', sa: 'Sa'},
      monthLabels: { 1: 'Jan', 2: 'Feb', 3: 'Mrz', 4: 'Apr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Okt',
        11: 'Nov', 12: 'Dez' },
      dateFormat: 'dd.mm.yyyy',
      yearSelector: false,
      monthSelector: false,
      selectBeginDateTxt: 'Startdatum auswählen',
      selectEndDateTxt: 'Enddatum auswählen',
      showClearBtn: true,
      showApplyBtn: true,
      openSelectorOnInputClick: true,
      disableUntil: {
        year: now.year(),
        month: now.month() + 1,
        day: now.date()
      },
      disableSince: {
        year: nextMonth.year(),
        month: nextMonth.month() + 1,
        day: nextMonth.date()
      },
      height: '26px',
      width: '239px'
    };
    this.dateRangeModel = {
      beginDate: {
        year: now.year(),
        month: now.month() + 1,
        day: now.date() + 1
      },
      endDate: {
        year: endDate.year(),
        month: endDate.month() + 1,
        day: endDate.date()
      }
    };
  }

  // ===================================================
  // Utility Area
  // ===================================================

  /**
   * Opens a new mass-sms modal with the given contacts
   * @param contacts the contacts to send an sms to
   * @param recipientType the contacts recipient type
   */
  newMassSms(contacts, recipientType, showBranchFilter?, weeks?: number) {
    this.modalRef = this.modalService.open(MassSmsComponent, {size: 'lg', backdrop: 'static', windowClass: 'xl'});
    if (recipientType === 'marketmasters') {
      this.modalRef.componentInstance.marketmasters = this.finalContacts;
    } else {
      this.modalRef.componentInstance.contacts = contacts;
    }
    this.modalRef.componentInstance.recipientType = recipientType;
    this.modalRef.componentInstance.showBranchFilter = showBranchFilter;
    if (weeks) { this.modalRef.componentInstance.numberOfWeeks = weeks; }
    this.loadingOverlay = false;
  }

  /**
   * checks if a specific contact is selected or not
   * @param contact the contact to search for
   */
  isCheckedForMassSms(contact: Contact | MerchantContact): boolean {
    return this.contactSelection && this.contactSelection.some((c) => c.id === contact.id);
  }

  /**
   * Changes the selection status of a given contact
   * @param contact the contact to change selection status of
   */
  changeSelectionForMassSms(contact: Contact | MerchantContact): void {
    if (this.isCheckedForMassSms(contact)) {
      this.contactSelection.splice(this.contactSelection.findIndex(i => i.id === contact.id), 1);
    } else {
      this.contactSelection.push(contact as Contact);
    }
  }

  async initFilters() {

    this.branchFilter = {
      label: 'Niederlassung',
      options: [
        {
          value: 'all',
          label: 'alle Niederlassungen'
        }
      ],
      selected: {
        value: 'all',
        label: 'alle Niederlassungen'
      }
    };
    const branches = await this.apiService.getBranches();
    branches.forEach(branch => {
      this.branchFilter.options.push({
        value: branch.name,
        label: branch.name
      });
    });

    this.functionFilter = {
      label: 'Funktion',
      options: [
        {
          value: 'all',
          label: 'alle Funktionen'
        }
      ],
      selected: {
        value: 'all',
        label: 'alle Funktionen'
      }
    };
    this.appPermissionFilter = {
      label: 'App Berechtigung',
      options: [
        {
          value: 'all',
          label: 'alle'
        },
        {
          value: 'vorhanden (Live-System)',
          label: 'vorhanden (Live-System)'
        },
        {
          value: 'vorhanden (Schulungssystem)',
          label: 'vorhanden (Schulungssystem)'
        },
        {
          value: 'nicht vorhanden',
          label: 'nicht vorhanden'
        }
      ],
      selected: {
        value: 'all',
        label: 'alle'
      }
    };
    this.recipientFilter = {
      label: 'Empfängergruppe',
      selected: { label: 'Bitte wählen', value: 'none'},
      options: [
        {
          label: 'Alle Märkte',
          value: 'all'
        },
        {
          label: 'Märkte einer bestimmten Niederlassung',
          value: 'branch'
        },
        {
          label: 'Märkte einer bestimmten Kommune',
          value: 'commune'
        }
      ]
    };
    this.communeFilter = {
      label: 'Kommune',
      selected: { label: 'Bitte wählen', value: 'none'},
      options: [
        {
          label: 'Alle',
          value: 'all'
        },
      ]
    };
  }

  /**
   * Resets the arrays allContacts, filteredContacts & contactSelection
   * @param contacts the contact array to set
   */
  private resetContacts(contacts: Contact[]) {
    this.allContacts = [...contacts];
    this.filteredContacts = [...contacts];
    this.contactSelection = [...contacts];
  }

  fillCommuneFilter() {
    if (this.allMarkets) {
      this.allMarkets.forEach(market => {
        if (this.communeFilter.options.some(item => item.value === market.branch)) {
          this.communeFilter.options.push({
            value: market.branch,
            label: market.branch
          });
        }
      });
    }
  }

  async getBranches(): Promise<any> {
      const branches = await this.apiService.getBranches();
      this.branches = branches
        .filter((branch: Branch) => branch.branchNumber !== 10 && branch.branchNumber !== 11);
      this.branchesWithCommunes = this.branches.map((branch: Branch) => ({branch: branch, communes: []}))
        .sort((a, b) =>
          a.branch.branchNumber - b.branch.branchNumber);
      if (!this.account.authorities.some((role: string) => role === 'ROLE_ADMIN')) {
        this.branches = this.branches.filter((branch: Branch) => branch.name === this.account.contact.branchString
          || this.account.contact.branches.split('|').some(accountBranch => accountBranch === branch.name));
        this.branchesWithCommunes = this.branchesWithCommunes
          .filter((branchWithCommune: {branch: Branch, communes: Array<string>}) =>
            branchWithCommune.branch.name === this.account.contact.branchString
            || this.account.contact.branches.split('|').some(accountBranch => accountBranch === branchWithCommune.branch.name));
      }
  }

  // ===================================================
  // Employee Mass-Sms Area
  // ===================================================

  /**
   * Fetches all employees from the api, stores
   * the contacts in this.allContacts and
   * fills the filters
   */
  getEmployees(ignoreFilters?): Promise<boolean> {
    return new Promise(((resolve, reject) => {
      this.apiService.find<Contact>(Contact, 'employees/').subscribe((contacts) => {
        this.resetContacts(contacts.filter(employee => employee.employeeActive !== 'False'));
        if (!ignoreFilters) {
          this.initFilters();

          this.functionFilter.options.push(
            {
              value: 'Verwaltung',
              label: 'Verwaltung'
            }
          );

          this.functionFilter.options.push(
            {
              value: 'Marktmeister',
              label: 'Marktleitung'
            }
          );
        }
        resolve(true);
      }, (error) =>  reject(error));
    }));
  }

  /**
   * Opens an new modal for employee selection & filtering by the user
   */
  openEmployeeSmsModal() {
    this.getEmployees().then(() => {
      this.filteredContacts.sort((a, b) => Number.parseInt(a.merchantNumber) > Number.parseInt(b.merchantNumber) ? 1 : -1);
    });
    this.modalRef = this.modalService.open(this.employeeModal, {size: 'lg', windowClass: 'xl'});
  }

  /**
   * Sets the selected filter option of an filter &
   * calls  this.filterEmployee()
   * @param filter the filter object
   * @param filterOption the selected filter option
   * @param fn the function to call after selected filter is changed
   */
  changeFilter(filter: Filter, filterOption: {label: string, value: string}, fn?) {
    console.log('changing filters');
    filter.selected = filterOption;
    if (fn) { fn(); }
  }

  /**
   * Filters the allContacts array.
   * This only works with employees, but not with merchants!
   */
  filterEmployees() {
    this.filteredContacts = null;

    setTimeout(() => {
      this.filteredContacts = this.allContacts.filter(contact => {
        return ((this.branchFilter.selected.value !== 'all')
          ? contact.branchString === this.branchFilter.selected.value : true)
          && ((this.functionFilter.selected.value !== 'all')
            ? contact.category.search(this.functionFilter.selected.value) !== -1 : true)
          && ((this.appPermissionFilter.selected.value !== 'all'
            ? (this.appPermissionFilter.selected.value === 'vorhanden (Live-System)'
              || this.appPermissionFilter.selected.value === 'vorhanden (Schulungssystem)')
              ? (contact.user && contact.user.activated
                && (this.appPermissionFilter.selected.value === 'vorhanden (Live-System)'
                  ? !contact.user.training : contact.user.training))
              : !(contact.user && contact.user.activated)
            : true));
      });
      this.filteredContacts.sort((a, b) => Number.parseInt(a.merchantNumber) > Number.parseInt(b.merchantNumber) ? 1 : -1);
      this.contactSelection = [...this.filteredContacts];
    }, 10);
  }

  // ===================================================
  // Market Masters Mass-Sms Area
  // ===================================================
  /**
   * Opens a modal with a date range selector & displays all MarketOverviewViewEntry's
   * within the selected period. User can filter & (un-) select markets
   */
  openSelectDateModal(disableReload?) {
    if (!disableReload) {
      this.initFilters();
      this.getMarkets(['Unopened']).then();
      this.getEmployees(true).then();
    }
    this.modalRef = this.modalService.open(this.selectDateModal, {size: 'lg', windowClass: 'xl'});
  }

  /**
   * Queries all MarketOverviewViewEntry's from the api based on the selected date range.
   * It sorts the data by date & (re-)initializes all relevant objects
   */
  getMarkets(status: string[], beginDate?: string, endDate?: string): Promise<boolean> {
    this.loadingIndicator = true;
    return new Promise(((resolve, reject) => {

      let beginDateStr;
      let endDateStr;
      if (!beginDate && !endDate) {
        const begin = this.dateRangeModel.beginDate;
        const end = this.dateRangeModel.endDate;
        beginDateStr = begin.year + '-' + begin.month.toString(10).padStart(2, '0')
          + '-' + begin.day.toString(10).padStart(2, '0');
        endDateStr = end.year + '-' + end.month.toString(10).padStart(2, '0')
          + '-' + end.day.toString(10).padStart(2, '0');
      } else {
        beginDateStr = beginDate;
        endDateStr = endDate;
      }
      this.apiService.getMarkets<MarketOverviewViewEntry>(MarketOverviewViewEntry,
        'backoffice/overview-by-status/' + beginDateStr + '/' + endDateStr + '/', status)
        .subscribe((data) => {
          // Sort markets by date asc
          data = data.sort((a, b) => {
            if (a.evasiveDate < b.evasiveDate) {
              return -1;
            } else if (a.evasiveDate > b.evasiveDate) {
              return 1;
            } else {
              return 0;
            }
          });
          // (re-) initialize all relevant objects
          this.allMarkets = [...data];
          this.filteredMarkets = [...data];
          this.selectedMarkets = [...data];
          [...Array.from(new Set(this.allMarkets.map(market => market.branch)))]
            .sort()
            .forEach(branchString => {
              if (branchString && branchString !== '' && !this.branchFilter.options.some(item => item.value === branchString)) {
                this.branchFilter.options.push({
                  value: branchString,
                  label: branchString
                });
              }
            });
          this.federalStates = [];
          this.allMarkets.forEach(market => {
            if (!this.federalStates.some(state => state === market.federalState) && market.federalState) {
              this.federalStates.push(market.federalState);
            }
          });
          this.shouldReload = false;
          this.loadingIndicator = false;
          resolve(true);
        }, (error => reject(error)));
    }));
  }

  filterMarkets() {
    this.filteredMarkets = [];
    setTimeout(() => {
      this.filteredMarkets = this.allMarkets.filter(market => market.branch === this.branchFilter.selected.value);
    }, 10);
  }

  /**
   * Filters the selected markets based on branch and federalState
   * Uses this.selectedFederalStates for state filtering
   * @param filterOption the branch filter option to use for filtering
   */
  applyMarketFilters(branchFilterOption) {
    this.branchFilter.selected = branchFilterOption;
    this.filteredMarkets = [...this.allMarkets];
    this.selectedMarkets  = [...this.allMarkets];

    if (branchFilterOption.value !== 'all')  {
      this.filteredMarkets = this.allMarkets.filter(market => market.branch === branchFilterOption.value);
    }

    if (this.selectedFederalStates && this.selectedFederalStates.length > 0) {
      if (!this.selectedFederalStates.some(item => item === 'all')) {
        this.filteredMarkets = this.filteredMarkets
          .filter(market => this.selectedFederalStates.some(state => state === market.federalState));
      }
    }
    this.selectedMarkets  = [...this.filteredMarkets];
  }

  /**
   * Changes the status of an market.
   * Only markets with an checked checkbox will be used for mass sms
   */
  changeMarketStatus(market) {
    if (this.selectedMarkets.some(m => m.marketdateId === market.marketdateId)) {
      this.selectedMarkets = this.selectedMarkets.filter(m => m.marketdateId !== market.marketdateId);
    } else {
      this.selectedMarkets.push(market);
    }
  }

  isMarketSelected(market) {
    return this.selectedMarkets.some(m => m.marketdateId === market.marketdateId);
  }

  /**
   * Get the market master contacts based on the selected markets
   * and opens a new mass sms modal
   */
  getMarketMasterDetails(showBranchFilter?, backToPlannedMarkets?) {
    this.finalContacts = [];
    this.selectedMarkets.forEach(market => {
      if (market.mm1Activated && market.mm1Id) {
          this.addFinalContact(market, market.mm1Id);
      }
      if (market.mm2Activated && market.mm2Id) {
        this.addFinalContact(market, market.mm2Id);
      }
      if (market.mm3Activated && market.mm3Id) {
        this.addFinalContact(market, market.mm3Id);
      }
    });
    this.newMassSms([], 'marketmasters', showBranchFilter);

    // Enable component back Button and subscripe to close Event, so that we can re-open the last modal
    this.modalRef.componentInstance.backToPlannedMarkets = backToPlannedMarkets;
    this.modalRef.componentInstance.modalCloses.subscribe(() => {
      this.openSelectDateModal(true);
    });
  }

  addFinalContact(market, mmId: number) {
    if (!this.finalContacts.some(contact => contact.contact.id === mmId)) {
      const contact = this.allContacts.filter((item) => item.id === mmId)[0];
      if (contact) {
        this.finalContacts.push({
          contact: contact,
          markets: [market]
        });
      }
    } else {
      this.finalContacts.forEach((contact) => {
        if (contact.contact.id === mmId) {
          contact.markets.push(market);
        }
      });
    }
  }

  /**
   * Opens an mass sms modal with all market masters from all markets today
   */
  sendMassSmsToTodayMM() {
    this.loadingIndicator = true;
    // Build date string for api call
    const now = new Date();
    const month = now.getMonth() + 1;
    const dateStr = now.getFullYear().toString(10).padStart(2, '0') + '-' +
      month.toString(10).padStart(2, '0') + '-' + now.getDate().toString(10).padStart(2, '0');

    this.getEmployees(true).then(() => {
      this.getMarkets(['Unopened', 'Opened', 'Closed', 'Confirmed'], dateStr, dateStr).then(() => {
        this.getMarketMasterDetails(true, false);
        this.loadingIndicator = false;
      }).catch((error) => {
        console.log(error);
        this.loadingIndicator = false;
      });
    }).catch((error) => {
      console.log(error);
      this.loadingIndicator = false;
    });
  }

  getFederalstateMarketCount(state: string) {
    return this.allMarkets.filter(market => market.federalState === state).length
  }

  // ===================================================
  // New Market Diary Entry Area
  // ===================================================

  openMarketDiaryModal() {
    this.initFilters();
    this.getBranches().then(() => this.getMarketplaces());
    this.getMarkets(['Unopened']).then(() => this.filterAllMarkets());
    this.modalRef = this.modalService.open(this.marketDiaryModal, {size: 'lg', backdrop: 'static', windowClass: 'xl'});
  }

  openMarketDiaryEntryModal() {
    this.modalRef = this.modalService.open(this.marketDiaryEntryModal, {size: 'lg', backdrop: 'static', windowClass: 'lg'});
  }

  /**
   * Return array of markets based on communes
   * @param commune
   */
  getMarketplaces(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.apiService.find<Marketplace>(Marketplace, 'marketplaces/', {params: {size: 500}})
        .subscribe((marketplaces: Array<Marketplace>) => {
          this.marketplaces = [...marketplaces];
          for (const marketplace of marketplaces) {
            if (marketplace.city && marketplace.city !== '' && marketplace.branch &&
              this.branches.some(branch => branch.id === marketplace.branch.id) &&
              this.branchesWithCommunes
                .some(branchesWithCommune => branchesWithCommune.branch.id === marketplace.branch.id) &&
              !this.branchesWithCommunes
                .find(branchesWithCommune => branchesWithCommune.branch.id === marketplace.branch.id).communes
                .some(commune => commune === marketplace.city)
            ) {
              this.branchesWithCommunes
                .find(branchesWithCommune => branchesWithCommune.branch.id === marketplace.branch.id)
                .communes.push(marketplace.city);
            }
            /*if (marketplace.federalState) {
              if (!this.federalStates.some(item => item === marketplace.federalState)) {
                this.federalStates.push(marketplace.federalState);
              }
            }*/
          }
          for (const branchWithCommune of this.branchesWithCommunes) {
            branchWithCommune.communes.sort((a, b) =>
              (a.toLowerCase() < b.toLowerCase()) ? -1 : (a.toLowerCase() > b.toLowerCase()) ? 1 : 0);
          }
          resolve();
        }, error => reject(error));
    });
  }

  /**
   * Return array of markets based on communes
   * @param commune
   */
  getMarketsByCommune(commune: string[]) {
    return this.allMarkets.filter(market => {
      const val = this.getCommuneFromMarket(market);
      return  commune.some(str => str === val);
    });
  }

  /**
   * Filters markets based on user selection
   */
  filterMarketsByRecipient() {
    this.filteredMarkets = [];
    setTimeout(() => {
      switch(this.recipientFilter.selected.value) {
        case 'all': {
          this.filteredMarkets = [...this.allMarkets];
          break;
        }
        case 'branch': {
          this.filteredMarkets = [...this.allMarkets].filter(market => market.branch === this.branchFilter.selected.value);
          break;
        }
        case 'commune': {
          this.filteredMarkets = [...this.allMarkets].filter(market => this.selectedCommunes.some(commune => commune === this.getCommuneFromMarket(market)));
          break;
        }
      }
      this.selectedMarkets = [...this.filteredMarkets];
    }, 10);
  }

  /**
   * Filter markets by marketTitle and date, to prevent duplicate entries.
   */
  filterAllMarkets() {
    let filtered = [];
    this.allMarkets.forEach(market => {
      const markets = this.allMarkets.filter(item => item.marketTitle === market.marketTitle)
        .sort((a, b) => { return new Date(a.evasiveDate).getTime() - new Date(b.evasiveDate).getTime(); });
      if (!filtered.some(x => x.marketTitle === market.marketTitle)) {
        filtered.push(markets[0]);
      }
    });
    this.allMarkets = filtered;
  }

  /**
   * Returns the commute as string from a given market
   */
  getCommuneFromMarket(market: MarketOverviewViewEntry) {
    return market.marketTitle.split(' / ')[0];
  }

  /**
   * get markets from api based on selected date range and re-applie filters
   */
  updateMarketsAndFilter() {
    this.getMarkets(['Unopened']).then(() => {
      this.filterAllMarkets();
      this.filterMarketsByRecipient();
    });
  }

  sendMarketDiaryEntry() {
    const markets: Marketdate[] = [];
    this.selectedMarkets.forEach(market => {
      markets.push({
        id: parseInt(market.marketdateId),
        marketdayNumber: market.marketdayNumber
      });
    });
    const message = new Message();
    message.messageType = MessageType.Announcement;
    message.marketdates = markets;
    message.content = this.diaryMessage;
    message.created = new Date();
    message.updated = new Date();
    this.apiService.post(message, 'messages/')
      .subscribe(res => {
      }, error => console.log(error));
  }

  async openMarketWebsiteSmsModal(withPresentationOnly: boolean = false): Promise<any> {
    this.loadingOverlay = true;
    let data: MerchantContact[] = await this.apiService.find(MerchantContact,
      'marketwebsite-contacts-of-next-week?withPresentationOnly=' + withPresentationOnly).toPromise();

    // Filter duplicates
    data = Array.from(new Set(data.map(a => a.id)))
      .map(id => {
        return data.find(a => a.id === id)
    });

    if (!this.account.authorities.some((role: string) => role === 'ROLE_ADMIN')) {
      data = data.filter(item => item.marketplaceBranchString === this.account.contact.branchString
        || this.account.contact.branches.split('|').some(accountBranch => accountBranch === item.marketplaceBranchString));
    }

    await this.initFilters();
    await this.getBranches();
    this.allContacts = [];
    this.federalStates = [];
    this.branchFilter.label = 'Marktort';
    this.branchFilter.selected = {value: 'all', label: 'Alle Marktorte'};
    this.branchFilter.options = [{value: 'all', label: 'Alle Marktorte'}];

    data = data.filter(c => c.casFunction !== 'Büromitarbeiter');
    for (const item of data) {

      if (!this.branchFilter.options.some(o => o.value === item.marketplaceCity)) {
        this.branchFilter.options.push({value: item.marketplaceCity, label: item.marketplaceCity});
      }
      if (!this.functionFilter.options.some(o => o.value === item.casFunction) && item.casFunction !== '') {
        this.functionFilter.options.push({value: item.casFunction, label: item.casFunction});
      }
      if (!this.federalStates.some(s => s === item.marketplaceFederalState)) {
        this.federalStates.push(item.marketplaceFederalState);
      }
      const communes = this.branchesWithCommunes.filter(branch => branch.branch.name === item.marketplaceBranchString)[0].communes;
      if (!communes.some(commune => commune === item.marketplaceCity)) {
        communes.push(item.marketplaceCity);
      }
    }

    this.communeFilter.options.sort((a, b) => a.value > b.value ? 1 : a.value < b.value ? -1 : 0);
    this.recipientFilter.options = [];
    this.recipientFilter.selected = null;

    const account = await this.principal.identity();
    if (account.authorities.some(role => role === 'ROLE_ADMIN')) {
      this.recipientFilter.options.push(
        { value: 'all', label: 'Alle Beschicker (unternehmensweit)' },
        { value: 'branch', label: 'Alle Beschicker einer bestimmten Niederlassung' }
      );
    }
    this.recipientFilter.options.push(
      { value: 'federalstate', label: 'Alle Beschicker eines bestimmten Bundeslandes' },
      { value: 'commune', label: 'Alle Beschicker einer bestimmten Kommune' },
      // { value: 'marketdate', label: 'Alle Beschicker eines bestimmten Markttages' }
    );

    this.branchFilter.options.sort((a, b) => a.value > b.value ? 1 : a.value < b.value ? -1 : 0);
    this.branchFilter.options.sort((a, b) => a.value === 'all' ? -1 : b.value === 'all' ? 1 : 0);
    this.allMerchantContacts = [...data];

    this.loadingOverlay = false;
    this.modalService.open(this.selectReceiverModal, {size: 'lg', windowClass: 'xl'});
  }

  filterMerchantContacts() {
    this.merchantContacts = [...this.allMerchantContacts];
    if (this.functionFilter.selected.value !== 'all') {
      this.merchantContacts = this.merchantContacts.filter(contact => contact.casFunction === this.functionFilter.selected.value);
    }
    if (this.branchFilter.selected.value !== 'all') {
      this.merchantContacts = this.merchantContacts.filter((contact: MerchantContact) => contact.marketplaceCity === this.branchFilter.selected.value);
    }
    this.contactSelection = [...this.merchantContacts];
  }

  sendMerchantContactsToMassSms() {
    this.merchantContacts = [...this.allMerchantContacts];
    switch(this.selectedRecipientGroupValue) {
      case 'all':
        break;
      case 'branch':
        if (this.selectedBranchId) {
          this.merchantContacts = this.merchantContacts.filter(c =>
            c.marketplaceBranchId.toString(10) === this.selectedBranchId.toString(10));
        }
        if(this.selectedFederalStates && this.selectedFederalStates.length > 0) {
          this.merchantContacts = this.merchantContacts.filter(c => this.selectedFederalStates.some(state => state === c.marketplaceFederalState || state === 'all'));
        }
        break;
      case 'federalstate':
        if(this.selectedFederalStates && this.selectedFederalStates.length > 0) {
          this.merchantContacts = this.merchantContacts.filter(c => this.selectedFederalStates.some(state => state === c.marketplaceFederalState || state === 'all'));
        }
        if (this.selectedBranchId) {
          this.merchantContacts = this.merchantContacts.filter(c =>
            c.marketplaceBranchId.toString(10) === this.selectedBranchId.toString(10));
        }
        break;
      case 'commune':
        this.merchantContacts = this.merchantContacts.filter(c => c.marketplaceCity === this.selectedCommune);
        break;
    }
    const contacts = this.merchantService.merchantContactsToContact(this.merchantContacts);
    this.newMassSms(contacts, 'merchantContactPersons', true);

    // Reset Filters
    this.selectedFederalStates = ['all'];
    this.selectedBranchId = null;
    this.selectedCommune = null;
    this.selectedRecipientGroupValue = null;
  }

  getMerchantContactByBranch(branchId: number, federalStates?: string[]) {
    if (federalStates) {
      const res = this.allMerchantContacts.filter(c =>
        this.selectedFederalStates.some(state => state === c.marketplaceFederalState || state === 'all'));
      return res.filter(c =>
        c.marketplaceBranchId.toString(10) === branchId.toString(10));
    } else {
      return this.allMerchantContacts.filter(c =>
        c.marketplaceBranchId.toString(10) === branchId.toString(10));
    }
  }

  getMerchantContactByState(federalState: string, branchId?: number) {
    if (branchId) {
      return this.getMerchantContactByBranch(branchId)
        .filter(c => c.marketplaceFederalState === federalState);
    } else {
      return this.allMerchantContacts.filter(c => c.marketplaceFederalState === federalState);
    }
  }

  getMerchantContactByCommune(commune: string) {
    return this.allMerchantContacts.filter(c => c.marketplaceCity === commune);
  }

  hasRecipientSelected(): boolean {
    switch (this.selectedRecipientGroupValue) {
      case 'all':
        return true;
      case 'federalstate':
      case 'branch':
        return this.selectedBranchId && (this.selectedFederalStates && this.selectedFederalStates.length > 0);
      case 'commune':
        return !!this.selectedCommune;
      default:
        return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/messages/components/messages/messages.component.ts